import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './ScrollBtn.css';

const ScrollBtn = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
            setVisible(scrollTop > 200);
        };

        toggleVisibility();
        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <button
            id="scroll-btn"
            className={`scroll-btn ${visible ? 'show-scroll' : ''}`}
            type="button"
            onClick={topFunction}
            aria-label="Scroll to top"
        >
            <FontAwesomeIcon icon={faChevronUp} />
        </button>
    );
};

export default ScrollBtn;